<v-grid v-if="submission.id">
  <v-row>
    <v-col has="10" off="1">
      <div class="out-left out-right">

        <section class="mt-section" :class="$style.myfontsSection">
          <div class="mt-line">
            <fou-picture
              v-if="getBinaryFontRenderSrc(getRegularStyleId(), submissionFamilyName)"
              :id="$vId(this, 'family-name-render')"
              :src="getBinaryFontRenderSrc(getRegularStyleId(), submissionFamilyName)"
              :alt="submissionFamilyName">
            </fou-picture>
            <h4 class="mt-serif mt-serif--size3" v-if="!getBinaryFontRenderSrc(getRegularStyleId(), submissionFamilyName)">
              {{submissionFamilyName}}
            </h4>
          </div>
          <fou-group>
            <div class="mt-line mt-serif--nowrap">
              <span class="mt-serif mt-serif--bold">Foundry: </span>
              <span>{{submissionVendorName}}</span>
            </div>
            <div class="mt-line">
              <span class="mt-serif mt-serif--bold">{{$t('pages.submissions.components.preview.designed_by')}}: </span>
              <span>{{designers}}</span>
            </div>
            <div class="mt-line">
              <span class="mt-serif mt-serif--bold">
                {{$t('pages.submissions.components.preview.defaultFontStyle')}}:
              </span>
              <span>{{submissionDefaultLayoutFont.name}}</span>
            </div>
            <div v-if="false" class="mt-line">
              <span class="mt-serif mt-serif--bold">
                {{$t('pages.submissions.components.preview.category')}}:
              </span>
              <span>{{submissionCategoryName}}</span>
            </div>
          </fou-group>
          
          <div v-if="getUserRoles(user) === 'foundrySupport'">
            <div class="mt-serif mt-serif--size6">
              {{$t('pages.submissions.components.preview.font_family_url')}}
            </div>
            <div class="mt-serif mt-serif--size4"
              :class="[$style.desUrl, $style.textUrlColor, $style.negMarBot30, $style.lowerCase, $style.scrollManage]">
              {{fontURI}}{{foundryRootDir}}/{{submissionFamilyURLName}}
            </div>
          </div>
        </section>


        <!--Packs ====================-->
        <section class="mt-section" :class="$style.myfontsSection">

          <div class="mt-line mt-flex mt-flex--between">
            <div v-if="familyPackage">
              <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4">
                {{$t('pages.submissions.components.preview.packages')}}
              </h4>
            </div>
            <div @click="() => downloadFonts(submission.id)" v-if="submissionBinaries.length > 0" class="mt-flex mt-flex--end">
              <download-icon :id="$vId(this, 'download-icon')" hover />
            </div>
          </div>

          <!--Family pack ====================-->
          <fou-group v-if="Object.keys(familyPackage).length > 0">
            <div class="mt-flex" :class="$style.c">
              <div class="mt-flex" :class="[$style.b, $style.b2, $style.x66]">
                <div :class="[$style.i, $style.r, $style.x100]">
                  <span class="mt-serif mt-serif--bold" :class="$style.familyPackageName">{{familyPackage.name}}</span>
                  <p class="mt-line">
                    <p class="mt-serif--microRegular mt-label--size12">
                      <span class="mt-label--capitalise" v-if="familyPackage.externalSku">
                        {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
                      </span>
                      {{familyPackage.externalSku}}
                    </p>
                  </p>
                </div>
                <div class="mt-flex" :class="[$style.c, $style.x100Nested]">
                  <div class="mt-flex mt-flex-stretch" :class="[$style.b, $style.x50]" v-for="style, key in familyPackage.styles">
                    <div :class="[$style.b1, $style.i, $style.x100]">
                      <div class="mt-line mt-serif mt-serif--size6" :class="$style.familyPackageName">
                        <span>{{submissionFamilyName}}</span>
                        <span style="margin-left:5px">{{style.binaryName}}</span>
                      </div>
                      <div
                        :class="$style.fontRender"
                        v-if="getBinaryFontRenderSrc(style.binaryId, style.binaryName)"
                        v-tooltip="{content: style.fileName, placement: 'bottom'}">
                        <fou-picture
                          full
                          class="mt-line"
                          :id="$vId(this, `family-pack-render-${key}`)"
                          :src="getBinaryFontRenderSrc(style.binaryId, style.binaryName, 24)"
                          :alt="style.binaryName" />
                      </div>
                    </div>
                  </div>
                  <div v-if="familyPackage.styles.length % 2 === 1" class="mt-flex mt-flex-stretch" :class="[$style.b, $style.x50]">
                    <div :class="[$style.b1, $style.i, $style.x100]"><!-- placeholder for odd style number --></div>
                  </div>
                </div>
              </div>
              <div class="mt-flex" :class="[$style.b, $style.b1]">
                <div class="mt-flex mt-flex--column mt-flex--between" :class="[$style.i, $style.r, $style.x100]">
                  <div>
                    <span class="mt-serif mt-serif--size6">{{getStyleNum(familyPackage)}}</span>
                    <div class="mt-serif mt-serif--size1">
                      <span>{{getUsdPrice(familyPackage)}}</span>
                    </div>
                    <p v-for="price, key in familyPackage.prices" v-if="price?.price > 0 && key > 0">
                      {{ price }} testing
                      <span>{{digitPrice(price?.price)}} {{price?.currency}}</span>
                    </p>
                  </div>
                  <div>{{getFormats(familyPackage.styles)}}</div>
                </div>
              </div>
            </div>
          </fou-group>

          <!--Custom packages ====================-->
          <fou-group v-if="customPackages.length > 0" v-for="pack, key in customPackages" :key="key">
            <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
              {{$t('pages.submissions.components.preview.custom_packages')}}
            </h4>
            <div class="mt-flex" :class="$style.c">
              <div class="mt-flex" :class="[$style.b, $style.b2, $style.x66]">
                <div :class="[$style.i, $style.r, $style.x100]">
                  <span class="mt-line mt-serif mt-serif--bold" :class="$style.familyPackageName">{{pack.name}}</span>
                  <p class="mt-line">
                    <p class="mt-serif--microRegular mt-label--size12">
                      <span class="mt-label--capitalise"  v-if="pack.externalSku">
                        {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
                      </span>
                      {{pack.externalSku}}
                    </p>
                  </p>
                </div>
                <div class="mt-flex" :class="[$style.c, $style.x100Nested]">
                  <div class="mt-flex mt-flex-stretch" :class="[$style.b, $style.x50]" v-for="style, key in pack.styles">
                    <div :class="[$style.b1, $style.i, $style.x100]">
                      <div class="mt-line mt-serif mt-serif--size6" :class="$style.familyPackageName">
                        <span>{{submissionFamilyName}}</span>
                        <span style="margin-left:5px">{{style.binaryName}}</span>
                      </div>
                      <div
                        :class="$style.fontRender"
                        v-if="getBinaryFontRenderSrc(style.binaryId, style.binaryName)"
                        v-tooltip="{content: style.fileName, placement: 'bottom'}">
                        <fou-picture
                          full
                          :id="$vId(this, 'custom-pack-style-render-' + key)"
                          class="mt-line"
                          :src="getBinaryFontRenderSrc(style.binaryId, style.binaryName, 24)"
                          :alt="style.binaryName" />
                      </div>
                    </div>
                  </div>
                  <div v-if="pack.styles.length % 2 === 1" class="mt-flex mt-flex-stretch" :class="[$style.b, $style.x50]">
                    <div :class="[$style.b1, $style.i, $style.x100]"><!-- placeholder for odd style number --></div>
                  </div>
                </div>
              </div>

              <div class="mt-flex" :class="[$style.b, $style.b1]">
                <div class="mt-flex mt-flex--column mt-flex--between" :class="[$style.i, $style.r, $style.x100]">
                  <div>
                    <span class="mt-serif mt-serif--size6">{{getStyleNum(pack)}}</span>
                    <div class="mt-serif mt-serif--size1">
                      <span>{{getUsdPrice(pack)}}</span>
                    </div>
                    <p
                      v-if="price?.price > 0 && key > 0"
                      v-for="price, key in pack.prices">
                      {{digitPrice(price?.price)}} {{price?.currency}}
                    </p>
                  </div>
                  <div>
                    {{getFormats(pack.styles)}}
                  </div>
                </div>
              </div>
            </div>
          </fou-group>
        </section>

        <!--Custom Family package with one style====================-->
        <section class="mt-section" :class="$style.myfontsSection" v-if="packages.length == 1 && getUserRoles(user) === 'foundrySupport'">
          <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
            {{$t('pages.submissions.components.preview.singleStyle')}}
          </h4>
          <fou-group>
            <div>
              <div class="mt-serif mt-serif--size6">
                {{$t('pages.submissions.components.preview.font_url')}}
              </div>
              <div v-if="!submission.isLive" class="mt-serif mt-serif--size4" :class="[$style.desUrl, $style.textUrlColor, $style.marBot15, $style.lowerCase, $style.scrollManage]">
                {{fontURI}}{{foundryRootDir}}/{{submissionFamilyURLName}}/{{customFamilyPackageSingleStyle}}
              </div>
              <div v-if="submission.isLive" class="mt-serif mt-serif--size4" :class="[$style.desUrl, $style.textUrlColor, $style.marBot15, $style.lowerCase, $style.scrollManage]">
                {{fontURI}}{{foundryRootDir}}/{{submissionFamilyURLName}}/{{submissionBinaries[0].uniqueName || customFamilyPackageSingleStyle}}
              </div>
            </div>
          </fou-group>
        </section>
        <!-- ====================-->

        <!--Single styles ====================-->
        <section class="mt-section" :class="$style.myfontsSection" v-if="singleStyles.length > 0">
          <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
            {{$t('pages.submissions.components.preview.singles')}}
          </h4>
          <fou-group v-for="pack, k in singleStyles" :key="k">
            <div v-if="getUserRoles(user) === 'foundrySupport'">
              <div class="mt-serif mt-serif--size6">
                {{$t('pages.submissions.components.preview.font_url')}}
              </div>
              <div v-if="!submission.isLive" class="mt-serif mt-serif--size4"
                :class="[$style.desUrl, $style.textUrlColor, $style.marBot15, $style.lowerCase, $style.scrollManage]">
                {{fontURI}}{{foundryRootDir}}/{{submissionFamilyURLName}}/{{pack.styles[0].styleURL}}
              </div>
              <div v-if="submission.isLive" class="mt-serif mt-serif--size4"
                :class="[$style.desUrl, $style.textUrlColor, $style.marBot15, $style.lowerCase, $style.scrollManage]">
                {{fontURI}}{{foundryRootDir}}/{{submissionFamilyURLName}}/{{submissionBinaries[k].uniqueName || pack.styles[0].styleURL}}
              </div>
            </div>
            <div class="mt-flex" :class="$style.c">
              <div class="mt-flex" :class="[$style.b, $style.b2, $style.x66]">
                <div :class="[$style.i, $style.r, $style.x100]">
                  <span class="mt-line mt-serif mt-serif--bold" :class="$style.familyPackageName">{{getSinglePack(pack)}}</span>
                  <p class="mt-line">
                    <p class="mt-serif--microRegular mt-label--size12">
                      <span class="mt-label--capitalise"  v-if="pack.externalSku">
                        {{$t('pages.submissions.components.upload.externalsku.external_sku_number')}}
                      </span>
                      {{pack.externalSku}}
                    </p>
                  </p>
                </div>

                <div :class="[$style.i, $style.r, $style.x100]">
                  <div class="mt-line mt-serif mt-serif--size6" :class="$style.familyPackageName">
                    <span>{{submissionFamilyName}}</span>
                    <span style="margin-left:5px">{{pack.styles[0].binaryName}}</span>
                  </div>
                  <div
                    :class="$style.fontRender"
                    v-if="getBinaryFontRenderSrc(pack.styles[0].binaryId, pack.styles[0].binaryName)"
                    v-tooltip="{content: pack.styles[0].fileName, placement: 'bottom-start'}">
                    <fou-picture
                      full
                      :id="$vId(this, 'custom-pack-style-render-' + pack.styles[0].binaryId)"
                      class="mt-line"
                      :src="getBinaryFontRenderSrc(pack.styles[0].binaryId, pack.styles[0].binaryName, 24)"
                      :alt="pack.styles[0].binaryName" />
                  </div>
                </div>

                <div :class="[$style.i, $style.r, $style.x100]" v-if="hasFeatures(pack.styles[0].binaryId)">
                  <div class="mt-serif mt-serif--size6">
                    <span>{{$t('pages.submissions.components.preview.ot_features')}}</span>
                    <span>{{getFeatureList(pack.styles[0].binaryId)}}</span>
                  </div>
                </div>

              </div>

              <div class="mt-flex" :class="[$style.b, $style.b1]">
                <div class="mt-flex mt-flex--column mt-flex--between" :class="[$style.i, $style.r, $style.x100]">
                  <div>
                    <span class="mt-serif mt-serif--size6">{{getStyleNum(pack)}}</span>
                    <div class="mt-serif mt-serif--size1">
                      <span>{{getUsdPrice(pack)}}</span>
                    </div>
                    <p v-for="price, key in pack.prices" v-if="price?.price > 0 && key > 0">
                      <span>{{digitPrice(price?.price)}} {{price?.currency}}</span>
                    </p>
                  </div>
                  <div>{{getFormats(pack.styles)}}</div>
                </div>
              </div>
            </div>
          </fou-group>

        </section>

        <!--Customer Message ====================-->
        <section
          class="mt-section"
          :class="$style.myfontsSection"
          v-if="submission.isLive && showCustomerMsgLabel">
          <fou-group>
            <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
              {{$t('pages.submissions.components.customerMessage.title')}}
            </h4>
            <p v-html="customerMsg"></p>
          </fou-group>
        </section>

        <!--Descriptions ====================-->
        <section
          class="mt-section"
          :class="$style.myfontsSection"
          v-if="familyDescriptions.length > 0">
          <fou-group v-for="desc, k in familyDescriptions" :key="k">
            <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
              {{$t('pages.submissions.components.preview.description')}}
            </h4>
            <p class="ql-editor description" v-html="HTTPinString(desc.description)"></p>
          </fou-group>
        </section>

        <!--Tags ====================-->
        <section
          class="mt-section"
          :class="$style.myfontsSection"
          v-if="submissionTags.length > 0">
          <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
            {{$t('pages.submissions.components.preview.tags')}}
          </h4>
          <div :class="[$style.negMarLeft5]">
            <div class="mt-tag mt-tag--hash" :class="[$style.tagItem]" v-for="tag in submissionTags">
              <div>{{tag.name}}</div>
            </div>
          </div>
        </section>

        <!--Related Families ====================-->
        <section
          class="mt-section"
          :class="$style.myfontsSection"
          v-if="submissionFamilies.families && submissionFamilies.families.length > 0 && getSelectedFoundry && getSelectedFoundry.contractSummary === 'UFDA 2'">
          <h4 class="mt-h4 mt-serif mt-serif--bold mt-serif--size4 mt-line">
            {{$t('pages.submissions.components.preview.related_families')}}
          </h4>
          <div :class="[$style.negMarLeft5]">
            <div :class="[!showPills?'mt-related-families--open':'']" class="mt-related-families mt-related-families--hash mt-related-families--group mt-related-families--group_open-btn" @click="changePillStatus"  v-if="maxFamiliesCount>0">
              {{ relatedFamiliesGroupName }}
              <span>+ {{ relatedFamiliesCount }}</span>
              <span class="icon-status-pill"></span>
            </div>
            <div class="mt-related-families mt-related-families--hash" :class="[$style.tagItem]" v-if="relatedFamiliesCount===0 || showPills" v-for="family in submissionFamilies.families">
              <div>{{family.familyName}}</div>
            </div>
          </div>
        </section>

        <!--Posters ====================-->
        <section
          v-if="((submissionImageSortorders[0] || {}).imageIds || [])[0]"
          class="mt-section"
          :class="$style.myfontsSection">
          <fou-group v-for="country, key in submissionImageSortorders" :key="key">
            <h4 class="mt-h4 mt-line">
              <span v-if="country.locationIso === 'US'" class="mt-serif mt-serif--bold mt-serif--size4">
                {{$t('pages.submissions.components.preview.default')}}
              </span>
              <span v-if="country.locationIso !== 'US'" class="mt-serif mt-serif--size4">
                {{$t(`data.countries.${country.locationIso}`)}}
              </span>
            </h4>
            <ul class="mt-list">
              <carousel
                :class="[$style.carouselDes, $style.widthCarousel]"
                :wrap-around="true"
                @slide-start="manageThumbnailIndex"
                :id="$vId(this)"
                ref="slider"
                v-model="slideTo"
              >
                <slide :class="[$style.vueCarouselSlide]" :id="$vId(this)" v-for="val in carouselImages" :key="val">
                  <div :class="[$style.loadingSlider]"
                    v-if="!(getPosterUrl(val)!=='')">
                    <animation-processing
                      :fill="$style.fillSpinner"
                      :class="$style.spinnerCarousel">
                    </animation-processing>
                  </div>
                  <img :class="[$style.widthCarousel]" :src="getPosterUrl(val, 'full')" />
                </slide>
                <template #addons>
                  <navigation>
                    <template #next>
                      <span :style="{ marginLeft: '5rem', fontSize: '16px' }">  ▶ </span>
                    </template>
                    <template #prev>
                      <span :style="{ marginRight: '5rem', fontSize: '16px' }"> ◀ </span>
                    </template>
                  </navigation>
                </template>
              </carousel>
              <li class="mt-list-item" :class="$style.thumbListItem" v-for="id, index in country.imageIds">
                <div :class="[{[$style.pictureBorder]: (slideTo === index)}]"
                  @click="()=>slideToImage(index)">
                  <div :class="[$style.uploaderProcessing]"
                    v-if="!(getPosterUrl(id)!=='')">
                    <animation-processing
                     :fill="$style.fillSpinner"
                     :class="$style.spinner"></animation-processing>
                  </div>
                  <fou-picture
                    :id="$vId(this, country.locationIso + '-thumb' + id)"
                    :class="[$style.pictureThumb]"
                    :src="getPosterUrl(id)"
                    v-tooltip="{content: getPosterFileName(id), placement: 'bottom'}"/>
                </div>
              </li>
            </ul>
          </fou-group>

          <!--Download link-->
          <div class="mt-flex mt-flex--end" @click="() => downloadGraphics(submission.id)" v-if="submissionImageSortorders.length > 0">
            <download-icon :id="$vId(this, 'download-icon')" hover></download-icon>
          </div>
        </section>

      </div>
    </v-col>
  </v-row>
</v-grid>
